import {UsersType} from "@/utilities/system/enums/Enums";

export class PathHelper {
    misc: MiscPathHelper = new MiscPathHelper();
    preferences:UserPreferencePathHelper = new UserPreferencePathHelper();
    users: UserPathHelper = new UserPathHelper();
    providers: ProviderPathHelper = new ProviderPathHelper();
    workers: ProviderWorkerPathHelper = new ProviderWorkerPathHelper();
    plants: PlantPathHelper = new PlantPathHelper();
    settings: SettingPathHelper = new SettingPathHelper();
    forms: FormPathHelper = new FormPathHelper();
}

class MiscPathHelper {
    getStartupConfigPath(){
        return `v1/startup`;
    }
    getChangelogPath(){
        return `v1/logs`;
    }
    getPubKeyPath(){
        return `v1/publickey`;
    }
}

class UserPreferencePathHelper {
    getUserPreferencePath(id:string, typeId:number){
        return `v1/preferences/${id}/types/${typeId}`;
    }
    getSaveUserPreferencesPath(){
        return `v1/preferences`;
    }
}

class UserPathHelper {
    getUsersPath():string {
        return `v1/users`;
    }
    getUsersWithAdditionalDataPath():string {
        return `v1/users/additional`;
    }
    getUserByIdPath(id:string){
        return `v1/users/${id}`;
    }
    getUserImportPath(userType:UsersType){
        return `v1/users/import/${userType}`;
    }
    getChangePasswordPath():string {
        return `v1/users/changePassword`;
    }
}

class ProviderPathHelper {
    getProvidersPath(){
        return `v1/providers`;
    }
    getProvidersByIdPath(id:string){
        return `v1/providers/${id}`;
    }
    getProviderByNamePath(providerName:string){
        return `v1/providers/search/${providerName}`;
    }
    getSimilarProviderPath(){
        return `v1/providers/search/similar`;
    }
    getProviderIdCodePath(){
        return `v1/providers/idCode`;
    }
    getConnectSystemToProviderPath(){
        return `v1/providers/connect`;
    }
    getProviderHasUserWithRolePath(id:string, role:string){
        return `v1/providers/${id}/hasRoles/${role}`;
    }
}

class ProviderWorkerPathHelper {
    getProviderWorkersPath(providerId:string){
        return `v1/workers/users/company/${providerId}/display`;
    }
    getProviderWorkersSelectablePath(){
        return `v1/workers/viewType/selectable`;
    }
    // when get -> userId, when post -> providerId
    getProviderWorkerByIdPath(id:string){
        return `v1/workers/${id}`;
    }
    getProviderWorkerByProviderAndUserPath(providerId:string, userId:string){
        return `v1/workers/company/${providerId}/worker/${userId}`;
    }
    getProviderWorkerStatusPath(userId:string){
        return `v1/workers/${userId}/status`;
    }
    getResetExpirationForProviderWorkerPath(providerId: string, userId: string){
        return `v1/workers/company/${providerId}/worker/${userId}/expiration`;
    }
    getSearchProviderWorkerByPhonenumberPath(providerId:string){
        return `v1/workers/search/worker/${providerId}`;
    }
    getPromoteProviderWorkerToAdminPath(providerId:string, userId:string){
        return `v1/workers/company/${providerId}/worker/${userId}/admin`;
    }
}

class PlantPathHelper{
    getPlantsPath(){
        return `v1/locations`;
    }
    getPlantByIdPath(id:string){
        return `v1/locations/${id}`;
    }
    getPlantImportPath(){
        return `v1/locations/import`;
    }
}

class SettingPathHelper {
    getGlobalSettingsPath(){
        return `v1/globalSettings`;
    }
    getUpdateGlobalSettingsPath(id:number){
        return `v1/globalSettings/${id}`;
    }
}

class FormPathHelper{
    getFormReportsPath(){
        return `v1/forms`;
    }
    getChangeFormOwnerPath(formId:string){
        return `v1/forms/owner/${formId}`;
    }
    getEnsurePdfCreationThenFetchPath(formId:string){
        return `v3/forms/${formId}/pdf`;
    }
    getGeneratePdfPath(formId:string){
        return `v3/forms/${formId}/pdf/generate`;
    }
}
